import { ColumnsType } from 'antd/lib/table'
import formatNumber from '../../../../../helpers/formatters/format-any-number'
import renderDate from '../../../../../helpers/tables/render-date'
import Machine from '../../../../../types/api/machine'
import RewindJob from '../../../../../types/api/rewind-job'
import ShipmentPosition from '../../../../../types/api/shipment-position'
import ActionsCell from './components/actions-cell'

export const getColumns = (machines: Machine[]): ColumnsType<RewindJob> => [
    { dataIndex: 'id', title: '№', width: 60 },
    {
        dataIndex: ['shipment', 'print_job', 'id'],
        title: 'Номер печати',
        width: 90,
        render: (_value, record) => record.shipment?.print_job?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'id'],
        title: 'Номер отгрузки',
        width: 95,
        render: (_value, record) => record?.shipment?.id || '—',
    },
    {
        dataIndex: ['shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 95,
        render: (_value, record) => {
            const clientDeliveryDate = record.shipment?.clientDeliveryDate

            return clientDeliveryDate ? renderDate(clientDeliveryDate) : '—'
        },
    },
    {
        dataIndex: ['shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['shipment', 'id'],
        title: 'Вид',
        width: 70,
        render: (_value, record) => record.shipment?.id || '—',
    },
    {
        dataIndex: ['shipment', 'shipment_positions'],
        title: 'Тираж',
        width: 90,
        render: (_value: ShipmentPosition[], record) =>
            formatNumber(
                (record.shipment?.shipment_positions || []).reduce(
                    (acc, position) => acc + (position.copies || 0),
                    0
                )
            ),
    },
    {
        dataIndex: ['shipment', 'quantityPerRoll'],
        title: 'Намотка',
        width: 80,
        render: (_value, record) => record.shipment?.quantityPerRoll || '—',
    },
    {
        dataIndex: ['shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.shipment?.bushing || '—',
    },
    {
        dataIndex: 'actions',
        title: '',
        width: 88,
        fixed: 'right',
        render: (_value, record) => <ActionsCell rewindJob={record} machines={machines} />,
    },
]
